export default {
    data() {
        return {
            syncDialog:{
                show: false,
                syncUrl: '',
                sendTime: false,
            },
            editDialog: {
                edit: false,
                show: false,
                loading: false,
                form: {},
                isRich: true,
                isShowDel: false,
            },
            detailDialog: {
                edit: false,
                show: false,
                loading: false,
                form: {},
                isRich: true,
            },
        }
    },
    mounted() {
        setTimeout(() => {

            console.log(this);
            if (this.$refs.add) {
   //             this.ue.config.initialFrameWidth = this.$refs.add.$el.clientWidth
   //             this.ue.finished = true
            }
        }, 300)
    },
    provide: {
        ins: self
    },
    methods: {
        detail(row) {
            this.detailDialog.form = this.$help.deepClone(row);
            this.detailDialog.show = true;
        },
        add() {
            const form = {};
            this.cols.forEach(item => {
                this.$set(form, item.key, '')
            })
            this.editDialog.form = form;
            this.editDialog.edit = false;
            this.editDialog.show = true;
            this.editDialog.loading = false;
            this.editDialog.isShowDel = false;
            this.addParamInit && this.addParamInit()
            // this.$nextTick(() => {
            //     this.$refs.form.resetFields();
            // })
        },
        // ready() {
        //     // if (this.config.lookStatus ===variable.lookStatus.LOOK) {
        //     //     this.$refs.neditor.editor.setDisabled()
        //     // } else {
        //     //     this.$refs.neditor.editor.setEnabled()
        //     // }
        //     this.ue.content = this.form.contentText || ''
        // },
        update(row) {
            this.editDialog.form = this.$help.deepClone(row);
            this.editDialog.edit = true;
            this.editDialog.show = true;
            this.editDialog.loading = false;
            this.editDialog.isShowDel = true;
            // this.$nextTick(() => {
            //     this.$refs.form.resetFields();
            // })
        },
        editSave(form) {
            if (!form) {
                form = this.$help.deepClone(this.editDialog.form);
            }


            //新增和修改，参数修改
            if (this.editParam) {
                form = this.editParam(form)
            }

            if(this.$refs.add && this.$refs.add.ue.content) {
                form.contentText = this.$refs.add.ue.content;
            }


            if (this.editDialog.edit) {
                // 修改参数修改
                if (this.updateParam) {
                    form = this.updateParam(form)
                }
            } else {
                // 新增参数修改
                if (this.addParam) {
                    form = this.addParam(form)
                }
            }

            this.editDialog.loading = true;
            this.$api.post(this.editDialog.edit ? this.api.update : this.api.add, form)
                .then(res => {
                    this.$help.success(res.msg);
                    this.init();
                    this.editDialog.show = false;
                })
                .finally(() => {
                    this.editDialog.loading = false;
                })
        },
        del(row) {
            this.$store.commit('confirm', {
                content: '确定删除吗',
                callback:(next, back) => {
                    // delKey
                    const param = {
                        id: row.id,
                    }
                    if (this.delKey) {
                        param[this.delKey] = row[this.delKey];
                    }
                    this.$api.post(this.api.del, param)
                        .then(res => {
                            next();
                            this.init();
                            this.$help.success(res.msg);
                        })
                        .finally(back)
                },
            })
        },
        delEdit(form) {
            this.$store.commit('confirm', {
                content: '确定删除吗',
                callback:(next, back) => {
                    console.log(form);
                    if (!form) {
                        form = this.$help.deepClone(this.editDialog.form);
                    }
                    // delKey
                    const param = {
                        id: form.id,
                    }
                    if (this.delKey) {
                        param[this.delKey] = form[this.delKey];
                    }
                    this.editDialog.loading = true;
                    this.$api.post(this.api.del, param)
                        .then(res => {
                            next();
                            this.$help.success(res.msg);
                            this.init();
                            this.editDialog.show = false;
                        })
                        .finally(() => {
                            this.editDialog.loading = false;
                            back();
                        })
                },
            })
        },
        showSync(){
            this.syncDialog.show = true;
        },

    }
}
